import {
    ModalOverlay,
} from "@chakra-ui/react";

export const COLORS = [
    'telegram',
    'twitter',
    'whatsapp',
    'messenger',
    'facebook',
    'linkedin',
    'pink',
    'purple',
    'cyan',
    'blue',
    'teal',
    'green',
    'yellow',
    'orange',
    'red',
    'gray',
    'blackAlpha'
]

export const OverlayOne = () => (
    <ModalOverlay
        bg="blackAlpha.300"
        backdropFilter="blur(10px) hue-rotate(90deg)"
    />
);


export const removeKeys = (data, keysToRemove) => {
    // Check if data is an array
    if (Array.isArray(data)) {
        return data.map(item => {
            const { ...rest } = item; // Spread the item
            keysToRemove.forEach(key => delete rest[key]); // Remove specified keys
            return rest; // Return the updated item
        });
    } else if (typeof data === 'object' && data !== null) {
        const { ...rest } = data; // Spread the object
        keysToRemove.forEach(key => delete rest[key]); // Remove specified keys
        return rest; // Return the updated object
    }
    // Return the original data if it's not an object or an array
    return data;
}

export const serializeDataForSelect = (arr, key) => {
    return arr.map((item) => ({
        ...item,
        label: item[key],
        value: item[key],
    }));
};
